import Vue from "vue";
import Router from "vue-router";
import Text from "@/views/Text";
import Upload from "@/views/Upload";
import CheckPhoto from "@/views/CheckPhoto";
import Order from "@/views/Order";
import OrderStatus from "@/views/OrderStatus";
import Instructions from "@/views/Instructions";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Text,
      props: { text_id: 1 }
    },
    {
      path: "/tips",
      name: "tips",
      component: Text,
      props: { text_id: 2 }
    },
    {
      path: "/instructies",
      name: "instructies",
      component: Instructions
    },
    {
      path: "/veelgestelde-vragen",
      name: "faq",
      component: Text,
      props: { text_id: 3 }
    },
    {
      path: "/over-de-app",
      name: "about",
      component: Text,
      props: { text_id: 4 }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Text,
      props: { text_id: 5 }
    },
    {
      path: "/service",
      name: "service",
      component: Text,
      props: { text_id: 6 }
    },
    {
      path: "/hoe-werkt-het",
      name: "tutorial",
      component: Text,
      props: { text_id: 7 }
    },
    {
      path: "/photo",
      name: "photo",
      component: Upload
    },
    // {
    //   path: "/photo-preview",
    //   name: "photo-preview",
    //   component: Preview
    // },
    {
      path: "/check-photo",
      name: "check-photo",
      component: CheckPhoto
    },
    {
      path: "/order",
      name: "order",
      component: Order
    },
    {
      path: "/order-status",
      name: "order-status",
      component: OrderStatus
    }
  ]
});
